import querystring from 'query-string';
import { template } from 'lodash';
import axios from './client';

const CREATE = '/user';
const UPDATE_EMAIL = '/update-email';
const CONFIRM_CHANGE_EMAIL = '/confirm-change-email';

const USER_URL = template('/user/<%= id %>');
const UPDATE_EMAIL_URL = template('/user/<%= id %>/update-email');
const UPDATE_PASSWORD_URL = template('/user/<%= id %>/update-password');

const USER_EMAIL_NOTIFICATION = template('/user/<%= id %>/email-notification');
const CONFIRM_ACCOUNT = template('/user/<%= id %>/confirm-account');

const USER_NEWS_AND_UPDATES = template('/user/<%= id %>/news-updates');

export function getUserEmailNotification(id) {
  return axios.get(USER_EMAIL_NOTIFICATION({ id }));
}

export function updateUserEmailNotification(payload) {
  const { id } = payload;
  return axios.post(USER_EMAIL_NOTIFICATION({ id }), querystring.stringify(payload));
}

export function createUser(payload) {
  return axios.post(CREATE, querystring.stringify(payload));
}

export function user(payload) {
  const { id } = payload;
  return axios.get(USER_URL({ id }));
}

export function update(payload) {
  const { id } = payload;
  return axios.post(USER_URL({ id }), querystring.stringify(payload));
}

export function updateEmail(payload) {
  const { id } = payload;
  return axios.post(UPDATE_EMAIL_URL({ id }), querystring.stringify(payload));
}

export function updatePassword(payload) {
  const { id } = payload;
  return axios.post(UPDATE_PASSWORD_URL({ id }), querystring.stringify(payload));
}

export function changeEmail(email) {
  return axios.post(UPDATE_EMAIL, querystring.stringify({ email }));
}

export function confirmChangeEmail(payload) {
  return axios.post(CONFIRM_CHANGE_EMAIL, querystring.stringify(payload));
}

export function confirmAccount(id) {
  return axios.get(CONFIRM_ACCOUNT({ id }));
}

export function getUserNewsAndUpdates(id) {
  return axios.get(USER_NEWS_AND_UPDATES({ id }));
}
